<template>
  <v-dialog v-model="showDialog" :max-width="800" :persistent="loading">
    <v-card class="pa-0">
      <modal-bar
        :title="title"
        :loading="loading"
        @onClose="showDialog = false"
      />
      <v-simple-table dense class="pa-2">
        <template #default>
          <tbody v-if="!loading" class="custom-table-bordered">
            <tr class="bg-gray font-weight-bold">
              <td>
                Monto de pagos <br />en línea del mes <br />
                corriente
              </td>
              <td>
                Monto de pagos <br />
                en línea del último <b></b> trimestre cerrado
              </td>
              <td>
                % de pagos en línea <br />
                del último trimestre <br />cerrado
              </td>
            </tr>
            <tr>
              <td class="text-center">
                {{ formatNumber(data.Ielpayment, '$', 0) }}
              </td>
              <td class="text-center">
                {{ formatNumber(data.IelpaymentQuarter, '$', 0) }}
              </td>
              <td class="text-center">{{ formatFloat(data.Percent, 2) }}%</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <v-progress-linear class="mt-3" indeterminate color="teal" />
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-dialog>
</template>
<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import ModalBar from '@/components/modals/ModalBar.vue';

  export default {
    name: 'CustomersIELPayment',
    components: {
      ModalBar,
    },
    mixins: [numbersFormats],
    props: {
      title: {
        type: String,
        default: '% de Pagos en Línea',
      },
      value: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({
          Ielpayment: 0,
          IelpaymentQuarter: 0,
          Percent: 0,
        }),
      },
    },
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
